// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Icon-module__container___yvffm{border-radius:50%;width:2rem;height:2rem;padding:.375rem;text-align:center}
`, "",{"version":3,"sources":["webpack://./node_modules/mintel-taskbar/node_modules/mintel-react-ui/dist/package/Icon3.css"],"names":[],"mappings":"AAAA,gCAAgC,iBAAiB,CAAC,UAAU,CAAC,WAAW,CAAC,eAAe,CAAC,iBAAiB","sourcesContent":[".Icon-module__container___yvffm{border-radius:50%;width:2rem;height:2rem;padding:.375rem;text-align:center}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
